module.exports = __webpack_public_path__ + "img/u49.0e313bb9.png";